module.exports = __webpack_public_path__ + "media/packs/landing_page/images/como_funciona-700f4e74adc099dc51a17487e351f084.jpg";